module.exports = __webpack_public_path__ + "img/EDIT.59a166a9.svg";